import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
import { useLocalStorage } from 'hooks/useLocalStorage';

// material-ui
import { useTheme } from '@mui/material/styles';
import ButtonBase from '@mui/material/ButtonBase';
import CardContent from '@mui/material/CardContent';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Stack from '@mui/material/Stack';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

// project imports
import ProfileTab from './ProfileTab';
import SettingTab from './SettingTab';
import Avatar from 'components/@extended/Avatar';
import MainCard from 'components/MainCard';
import Transitions from 'components/@extended/Transitions';
import IconButton from 'components/@extended/IconButton';

// assets
import LogoutOutlined from '@ant-design/icons/LogoutOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import avatar1 from 'assets/images/users/avatar-1.png';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && children}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `profile-tab-${index}`,
    'aria-controls': `profile-tabpanel-${index}`
  };
}

// ==============================|| HEADER PROFILE (NEW UI) ||============================== //

export default function Profile() {
  const theme = useTheme();
    const { state, setState, setField, resetState } = useLocalStorage('user', null);

  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  const handleToggle = () => setOpen((prev) => !prev);
  const handleClose = (event) => {
    if (anchorRef.current?.contains(event.target)) return;
    setOpen(false);
  };

  const [value, setValue] = useState(0);
  const handleChange = (e, newValue) => setValue(newValue);

  return (
    <Box sx={{ flexShrink: 0, ml: 'auto' }}>
      {/* ⭐ USER ROW: Avatar + Name + Role + Arrow */}
      <ButtonBase
        ref={anchorRef}
        onClick={handleToggle}
        sx={{
          borderRadius: 1,
          px: 1.5,
          py: 0.5,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          '&:hover': { backgroundColor: 'rgba(255,255,255,0.08)' }
        }}
      >
        <Avatar alt="profile user"  size="sm" />

        {/* Name + Role */}
        <Stack sx={{ textAlign: 'left', display: { xs: 'none', sm: 'flex' } }}>
          <Typography variant="subtitle1" sx={{ color: '#404143ff', fontWeight: 600 }}>
            {state.fullName}
          </Typography>
          <Typography variant="caption" sx={{ color: '#404143ff' }}>
            {state.role}
          </Typography>
        </Stack>

        {/* Dropdown Arrow */}
        <KeyboardArrowDownIcon sx={{ color: '#404143ff' }} />
      </ButtonBase>

      {/* DROPDOWN POPPER */}
      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        transition
        disablePortal
        popperOptions={{ modifiers: [{ name: 'offset', options: { offset: [0, 9] } }] }}
      >
        {({ TransitionProps }) => (
          <Transitions type="grow" position="top-right" in={open} {...TransitionProps}>
            <Paper sx={{ width: 290 }}>
              <ClickAwayListener onClickAway={handleClose}>
                <MainCard elevation={0} border={false} content={false}>
                  {/* Header inside dropdown */}
                  <CardContent sx={{ px: 2.5, pt: 3 }}>
                    <Grid container justifyContent="space-between" alignItems="center">
                      <Grid>
                        <Stack direction="row" sx={{ gap: 1.25, alignItems: 'center' }}>
                          <Avatar  alt="profile user"  sx={{ width: 32, height: 32 }} />

                          <Stack>
                            {/* Name Black */}
                            <Typography variant="h6" sx={{ color: 'black' }}>
                              {state.fullName}
                            </Typography>

                            {/* Role Black */}
                            <Typography variant="body2" sx={{ color: 'black' }}>
                              {state.role}
                            </Typography>
                          </Stack>
                        </Stack>
                      </Grid>

                      {/* Dropdown Icon Black */}
                      {/* <Grid>
                        <Tooltip title="Open Menu">
                          <IconButton size="large" sx={{ color: 'black' }}>
                            <UserOutlined />
                          </IconButton>
                        </Tooltip>
                      </Grid> */}
                    </Grid>
                  </CardContent>

                  {/* Tabs */}
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange} variant="fullWidth">
                      <Tab icon={<UserOutlined />} label="Profile" {...a11yProps(0)} />
                      <Tab icon={<SettingOutlined />} label="Setting" {...a11yProps(1)} />
                    </Tabs>
                  </Box>

                  <TabPanel value={value} index={0}>
                    <ProfileTab />
                  </TabPanel>

                  <TabPanel value={value} index={1}>
                    <SettingTab />
                  </TabPanel>
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  value: PropTypes.number,
  index: PropTypes.number
};
